import logger, { LogLevelNames } from 'loglevel';

import config from '@ui-furniture/config';

logger.setDefaultLevel(config.logLevel as LogLevelNames);

export { logger };
